import type { CasinoConfig } from '@/types'

export const CASINO_CONFIG: CasinoConfig = {
  name: 'Cosa Nostra Casino',
  currency: 'ARS',

  // Demo initial chips
  demoBalance: 10000,

  // Bets
  minBet: 100,
  maxBet: 100000,

  // Payment data (configure with real data)
  payment: {
    mercadopago: {
      alias: 'cosa.nostra.casino',
      cvu: '0000003100000000000000',
      titular: 'COSA NOSTRA SRL',
    },
    transferencia: {
      cbu: '0000000000000000000000',
      alias: 'cosa.nostra.banco',
      banco: 'Banco Nación',
      titular: 'COSA NOSTRA SRL',
      cuit: '30-00000000-0',
    },
  },

  // Deposit
  minDeposit: 1000,
  maxDeposit: 10000,

  // Withdrawal
  minWithdrawal: 2000,
  maxDailyWithdrawal: 50000,
}

export const CHIP_VALUES = [50, 100, 500, 1000, 5000] as const

export const CHIP_COLORS: Record<number, string> = {
  50: 'bg-gray-600',
  100: 'bg-casino-green',
  500: 'bg-casino-blue',
  1000: 'bg-casino-red',
  5000: 'bg-casino-gold',
}
